import React from 'react';
import colors from '../../util/colors';

interface ArrowRightProps {
  color?: string;
}

function ArrowRight({color = colors.blue}: ArrowRightProps) {
  return (
    <svg
      width="10.68px"
      height="16.24px"
      viewBox="0 0 9 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <title></title>
      <g
        id="Consultas-online"
        stroke="none"
        stroke-width="1"
        fill={color}
        fill-rule="evenodd">
        <g
          id="MY-A-08-02-04"
          transform="translate(-327.000000, -232.000000)"
          fill={color}
          fill-rule="nonzero">
          <g
            id="MUTUAL/ICONS/Arrows/Right"
            transform="translate(327.085906, 232.976594)">
            <path
              d="M7.92764294,2.19729961 L4.00963656,6.54097192 L0.0777611761,2.18192383 C0.0512771204,2.15256819 0.0161931234,2.13233235 -0.0224794573,2.12411101 C-0.511940517,2.0200572 -0.958256773,2.12855227 -1.36142823,2.4495962 C-1.76023126,2.76716159 -2.00102504,3.20048819 -2.08380955,3.74957601 C-2.09204392,3.80419423 -2.07577698,3.85966453 -2.03934915,3.90118523 L2.9427707,9.57983961 C3.48876314,10.2655045 4.53050997,10.2655045 5.07650241,9.57983961 L10.0475277,3.9138309 C10.089836,3.86561088 10.104554,3.79910776 10.0865456,3.73753781 C9.90041285,3.1011586 9.6677951,2.67184473 9.3886923,2.4495962 C9.10774904,2.22588213 8.66566258,2.1211612 8.06243295,2.13543342 C8.01091064,2.13665772 7.96216161,2.1590307 7.92764294,2.19729961 Z"
              id="ELEMENTS/ICONS/Arrows/Right"
              transform="translate(4.004091, 6.089997) scale(1, -1) rotate(-90.000000) translate(-4.004091, -6.089997) "></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ArrowRight;
